import { BookOpen } from "lucide-react";
import TimeBackground from "../components/TimeBackground";
import BottomNav from "../components/BottomNav";

export default function Journal() {
  return (
    <TimeBackground overlay={0.7}>
      <div className="min-h-screen max-w-md mx-auto w-full px-6 pt-8 pb-28 flex flex-col items-center justify-center text-center gap-5">
        <div className="w-16 h-16 rounded-2xl glass flex items-center justify-center">
          <BookOpen size={28} strokeWidth={1.25} className="text-[#eac88a]" />
        </div>
        <h1 className="font-ui font-semibold text-[32px] text-gold-gradient leading-[1.1] tracking-tight">
          Your Journal
        </h1>
        <p className="font-ui text-[#f8ecd4]/80 text-[15px] max-w-sm leading-[1.6]">
          Save the stories that find you. Track what changes inside over time.
        </p>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#d4af7a]/35 text-[10px] tracking-[0.3em] uppercase text-[#d4af7a] font-ui">
          Coming soon
        </div>
      </div>
      <BottomNav />
    </TimeBackground>
  );
}
